export type EmployeeMilestoneType = "BIRTHDAY" | "WORK_ANNIVERSARY";

export interface EmployeeMilestone {
  type: EmployeeMilestoneType;
  userId: string;
  displayName: string;
  avatarUrl?: string | null;
  roles: string[];
  month: number;
  day: number;
  startYear?: number | null;
}

/**
 * Loads the organization-level employee milestone directory.
 *
 * The backend intentionally omits birthday years. Work-anniversary startYear is
 * included because it is required to calculate the anniversary number while the
 * user browses different calendar years.
 */
export async function getEmployeeMilestones(
  authToken: string,
): Promise<EmployeeMilestone[]> {
  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/CalendarEvent/milestones`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      errorText || `Failed to load employee milestones (${response.status}).`,
    );
  }

  const json = await response.json();
  return Array.isArray(json?.data) ? json.data : [];
}